import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { fetchAchievementProgressByName } from '../../apis/achievementsApi';
import Achievements from '../../enums/achievements';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import RankingTable from './rankingTable';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const Ranking = () => {
  const { user_id } = useParams();
  const [rankingAchievement, setRankingAchievement] = useState([]);
  const [historicRankingAchievement, setHistoricRankingAchievement] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadRankings = async () => {
      setLoading(true);
      const ranking = await fetchAchievementProgressByName(Achievements.RANKING);
      setRankingAchievement(ranking || []);
      const historicRanking = await fetchAchievementProgressByName(Achievements.HISTORIC_RANKING);
      setHistoricRankingAchievement(historicRanking || []);
      setLoading(false);
    };
    loadRankings();
  }, [user_id]);

  if (loading) {
    return (
      <div className="text-center mt-3">
        <Spin size="large" />
      </div>
    );
  }
  
  return (
    <div>
      <RankingTable
        user_id={user_id}
        ranking={rankingAchievement}
        ranking_name={dayjs.utc().locale('es').format('MMMM').charAt(0).toUpperCase() + dayjs.utc().locale('es').format('MMMM').slice(1)}
      />
      <RankingTable
        user_id={user_id}
        ranking={historicRankingAchievement}
        ranking_name={'Histórico'}
      />
    </div>
  );
};

export default Ranking;
